<template>
  <v-data-table :headers="headers" :items="data" hide-default-footer>
    <template v-slot:[`item.title`]="{ item }">
      <router-link to="/notice/view">{{ item.title }}</router-link>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: "No",
          value: "num",
          width: "10%",
          sortable: false,
        },
        {
          text: "제목",
          value: "title",
          width: "50%",
          sortable: false,
        },
        {
          text: "조회수",
          value: "view",
          width: "10%",
          sortable: false,
        },
        {
          text: "등록일",
          value: "date",
          width: "15%",
          sortable: false,
        },
        {
          text: "작성자",
          value: "author",
          width: "15%",
          sortable: false,
        },
      ],
      data: [
        {
          num: "★",
          title: "데브몬 전체회의 내용",
          view: 0,
          date: "2020-04-05",
          author: "관리자",
        },
        {
          num: "1",
          title: "데브몬 회식 일정",
          view: 0,
          date: "2020-04-05",
          author: "관리자",
        },
      ],
    };
  },
  methods: {
    // onEdit(item) {
    //   this.$emit("onEditClick", item);
    // },
    // onRemove(item) {
    //   this.$emit("removeProject", item);
    // },
  },
};
</script>

<style></style>
